import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function useCollection(col, month) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/data/${col}`, { params: month ? { month } : {} });
      setItems(data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  }, [col, month]);

  useEffect(() => {
    reload();
  }, [reload]);

  const add = async (body) => {
    try {
      const { data } = await api.post(`/data/${col}`, body);
      setItems((p) => [data, ...p].sort((a, b) => (b.date || "").localeCompare(a.date || "")));
      toast.success("Tersimpan!");
      return data;
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  const update = async (id, body) => {
    try {
      const { data } = await api.put(`/data/${col}/${id}`, body);
      setItems((p) => p.map((x) => (x.id === id ? data : x)));
      return data;
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  const remove = async (id) => {
    await api.delete(`/data/${col}/${id}`);
    setItems((p) => p.filter((x) => x.id !== id));
    toast("Dihapus");
  };

  return { items, loading, add, update, remove, reload };
}

export function usePrefs() {
  const [prefs, setPrefs] = useState(null);
  useEffect(() => {
    api.get("/prefs").then((r) => setPrefs(r.data));
  }, []);
  const save = async (patch) => {
    const { data } = await api.put("/prefs", patch);
    setPrefs(data);
    return data;
  };
  return { prefs, save };
}
